import {
  REFRESH_RESUMES,
	SET_RESUMES,
  ADD_RESUME,
  UPDATE_RESUME,
  GET_RESUME,
	FINISH_GET_RESUME,
  DELETE_RESUME,
  SET_BIO_RESUME
} from './types';

export const refreshResumes = () => {
	return {
    type: REFRESH_RESUMES,
    payload: null,
  };
}
export const setResumes = (params) => {
	return {
    type: SET_RESUMES,
    payload: params,
  };
}

export const addResume = (params) => {
	return {
    type: ADD_RESUME,
    payload: params,
  };
}

export const updateResume = (params) => {
	return {
    type: UPDATE_RESUME,
    payload: params,
  };
}

export const getResume = () => {
  return {
    type: GET_RESUME,
    payload: [],
  };
};

export const finishGetResume = (params) => {
  return {
    type: FINISH_GET_RESUME,
    payload: params,
  };
};

export const deleteResume = (params) =>{
  return {
    type: DELETE_RESUME,
    payload: params
  }
}

export const setBioResume = (params) =>{
  return {
    type: SET_BIO_RESUME,
    payload: params
  }
}